var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{'text-success':_vm.value && _vm.coloured, 'text-danger':!_vm.value && _vm.coloured}},[_c('i',{staticClass:"fa",class:{'fa-check':_vm.value, 'fa-times':!_vm.value}})])
}
var staticRenderFns = []

export { render, staticRenderFns }